import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { List, message } from 'antd';
import { Status } from '../helpers/consts/status';
import {
  fetchAdmins,
  addAdmin,
  editAdmin,
  removeAdmin,
} from '../store/actions/admin-actions';

import CardItem from '../components/UI/CardItem/CardItem';
import Spinner from '../components/UI/Spinner/Spinner';
import ModalForm from '../components/UI/Modal/Modal-form/ModalForm';
import PageHeader from '../components/UI/PageHeader/PageHeader';

const Admins = () => {
  const { t } = useTranslation();
  const { status, admins } = useSelector((state) => state.admin);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const dispatch = useDispatch();

  const [openForm, setOpenForm] = useState(false);

  useEffect(() => {
    // Fetch admins only if they are not already loaded
    if (status === Status.IDLE && admins.length === 0) {
      dispatch(fetchAdmins());
    }
  }, [dispatch, status, admins.length]);

  const onAddAdmin = () => {
    setSelectedAdmin(null);
    setOpenForm(true);
  };

  const onEditAdmin = (carHouseAdmin) => {
    setSelectedAdmin(carHouseAdmin);
    setOpenForm(true);
  };

  const deleteAdmin = async (id) => {
    console.log(id);
    try {
      await dispatch(removeAdmin(id));
      message.success('Successfully removed admin');
    } catch (err) {
      message.error('Something wrong');
    }
  };

  const addAdminHandler = async (body) => {
    try {
      await dispatch(addAdmin(body));
      message.success('Successfully added new admin');
      setOpenForm(false);
    } catch (err) {
      setOpenForm(false);
      message.error('Something wrong');
    }
  };

  const editAdminHandler = async (body) => {
    try {
      await dispatch(
        editAdmin({
          adminId: selectedAdmin.id,
          body,
        })
      );
      message.success('Successfully edit admin');
      setOpenForm(false);
    } catch (err) {
      setOpenForm(false);
      message.error('Something wrong');
    }
  };

  let content;
  if (status === Status.LOADING) {
    content = <Spinner />;
  } else if (status === Status.COMPLETED) {
    content = (
      <div className="container-fluid p-0">
        <List
          grid={{
            gutter: 16,
            xs: 1,
            sm: 2,
            md: 3,
            lg: 4,
            xxl: 4,
          }}
          dataSource={admins}
          renderItem={(item) => (
            <CardItem user={item} onEdit={onEditAdmin} onDelete={deleteAdmin} />
          )}
        />
      </div>
    );
  }

  return (
    <>
      <PageHeader title={t('navigation.admins')} onAdd={onAddAdmin} showButton buttonText={t('carHouse.addAdmin')}/>
      {content}
      <ModalForm
        open={openForm}
        selectedItem={selectedAdmin}
        add={addAdminHandler}
        edit={editAdminHandler}
        title="admin"
        onClose={() => {
          setOpenForm(false);
        }}
      />
    </>
  );
};

export default Admins;
